<template>
  <div>
    <!-- 修改弹窗 -->
    <div class="modify">
      <el-dialog
        title="导出"
        :visible.sync="dialogVisibleObj.export"
        :close-on-click-modal="false"
      >
        <div class="mian">
          <p>评分表名称：</p>
          <el-input v-model="titleName"></el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisibleObj.export = false">取 消</el-button>
          <el-button type="primary" @click="rename">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  props: [],
  data() {
    return {
      dialogVisibleObj: {
        export: false, //导出弹窗
      },
      sundflag: false, // 结束考试防抖
      titleName: "",
    };
  },
  methods: {
    rename() {
      this.renameClick();
      this.dialogVisibleObj.export = false
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.delete_view {
  .title_box {
    // height: 54px;
    padding-bottom: 9px;
    margin-bottom: 20px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 19px;
    color: #333333;
    border-bottom: 1px solid #abd7ff;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }
  ::v-deep .dialog-footer {
    margin-bottom: 30px;
  }
  ::v-deep.el-dialog__footer {
    justify-content: left !important;
  }
  span > button:nth-child(3) {
    margin-left: 50px;
  }
  ::v-deep .el-dialog__footer span > button:nth-child(2) {
    margin-left: 0;
  }
  .mian {
    p {
      text-align: center;
      span {
        color: red;
      }
    }
  }
  .el-dialog__footer span > button {
    margin-top: 10px;
  }
  ::v-deep .el-dialog {
    width: 300px;
    border-radius: 5px 5px 0px 0px;
    .input_layout {
      display: flex;
      > .el-form-item {
        flex: 1;
        display: flex;
        align-content: center;
        ::v-deep .el-input {
          width: 420px;
        }
        .son_input > input {
          width: 420px;
        }
      }
    }
  }
}

::v-deep .el-dialog__headerbtn .el-dialog__close {
  font-size: 24px;
  color: #fff;
}
::v-deep .el-dialog__header {
  height: 55px;
  background: #0084ea;
  opacity: 1;
  border-radius: 5px 5px 0px 0px;
  font-size: 16px;
  letter-spacing: 2px;
  font-family: PingFang SC;
  box-sizing: border-box;
  text-align: center;
  .el-dialog__title {
    color: #fff;
  }
}
::v-deep .el-dialog__wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
::v-deep .el-dialog__footer {
  padding: 0;
  text-align: center;
  display: flex;
  justify-content: center;
  align-content: center;
  button {
    width: 80px;
    height: 40px;
    border-radius: 2px;
    color: #fff;
    font-size: 14px;
    &:nth-child(1) {
      background: #c4c4c4;
      margin-right: 10px;
    }
    &:nth-child(2) {
      background: #0084ea;
    }
  }
}
.modify {
  .title_box {
    // height: 54px;
    padding-bottom: 9px;
    margin-bottom: 20px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 19px;
    color: #333333;
    border-bottom: 1px solid #abd7ff;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }
  ::v-deep .dialog-footer {
    margin-bottom: 30px;
  }
  ::v-deep.el-dialog__footer {
    justify-content: left !important;
  }
  span > button:nth-child(3) {
    margin-left: 50px;
  }
  ::v-deep .el-dialog__footer span > button:nth-child(2) {
    margin-left: 0;
  }
  .mian {
    display: flex;
    align-items: center;
    p {
      width: 120px;
    }
    ::v-deep .el-input__inner {
      width: 280px;
    }
  }
  .el-dialog__footer span > button {
    margin-top: 10px;
  }
  ::v-deep .el-dialog {
    width: 500px;
    border-radius: 5px 5px 0px 0px;
    .input_layout {
      display: flex;
      > .el-form-item {
        flex: 1;
        display: flex;
        align-content: center;
        ::v-deep .el-input {
          width: 420px;
        }
      }
    }
  }
}
</style>
